"use client";

import Intro from "@/ui/Intro";
import React from "react";

const partnerHighlights = [
  {
    title: "1st in India",
    desc: "to feature Learn & Earn during Degree",
  },
  {
    title: "1st in India",
    desc: "to promote NEP2020 with Industry Integration",
  },
  {
    title: "1st in India",
    desc: "to promote Overseas Mobility",
  },
  {
    title: "1st in India",
    desc: "to be the Awarding Body of UGC & NCVET, MSDE, GoI",
  },
];

const partnerStats = [
  { value: "650+", label: "Industry & Skilling Partners" },
  { value: "30+", label: "Sectors Covered" },
  {
    value: "20+",
    label: "Central Ministries & State Government Partners",
  },
  { value: "20+", label: "CSR Partners" },
  { value: "10+", label: "Defence Partners" },
];

const Partnership = () => {
  return (
    <section className=" ">

      <Intro title="Building India’s Skills Network" 
      description="Strategic collaborations with industry leaders and public institutions shaping employability at scale" />


      <div className="grid gap-6 grid-cols-2 sm:grid-cols-3 md:grid-cols-4 mb-12">
        {partnerHighlights.map((item, idx) => (
          <div
            key={idx}
            className="bg-[#00304b] px-6 py-6  border border-[#0b425f] 
                         hover:shadow-lg hover:-translate-y-1 transition-all duration-200 
                         flex flex-col gap-0 relative overflow-hidden"
          >
            <div className="pointer-events-none absolute inset-0 opacity-60">
              <div
                className={`absolute -bottom-10 right-0 w-40 h-40 rounded-full blur-3xl ${idx % 2 === 0 ? "bg-[#FFA20C]/80" : "bg-[#0091E3]/80"
                  }`}
              />
            </div>

            <p
              className="relative text-xl font-semibold  text-white"
              style={{ fontFamily: "saans-bold" }}
            >
              {item.title}
            </p>
            <p
              className="relative text-[16px] text-white"
              style={{ fontFamily: "saans-regular" }}
            >
              {item.desc}
            </p>
          </div>
        ))}
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 bg-white ">
        {partnerStats.map((stat, idx) => (
          <div
            key={idx}
            className={`flex flex-col items-start md:px-10 px-3 py-2 ${idx !== partnerStats.length - 1 ? "border-r border-black/10" : ""
              }`}
          >
            <span
              className="text-3xl sm:text-4xl font-bold text-[#ffa201] mb-1 leading-none"
              style={{ fontFamily: "saans-bold" }}
            >
              {stat.value}
            </span>
            <span
              className="text-xs sm:text-sm text-gray-800 text-start max-w-[190px] leading-[1.3]"
              style={{ fontFamily: "saans-regular" }}
            >
              {stat.label}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Partnership;